export const blockIconsNavigationArrowForwardiOS = (
	<span className='material-symbols-outlined'>arrow_forward_ios</span>
);
